import { authApi } from '../api/auth';
import { getBootstrap } from '../config/bootstrap';
import { browser } from '../utils/browser';
import { clearAuth } from './authStore';
import { CALLBACK_PATH } from './callback';

/**
 * Where an explicit Sign out lands (CNPWKS-0010): saas-login's signed-out screen, which does not auto-forward a
 * Microsoft-only tenant straight back into sign-in. `loginUrl` is used verbatim and extended with `URL`, so a query
 * it already carries survives. The return path is /auth/callback?next=/ (SASATH-0156): the next session starts at
 * home.
 */
export function signedOutUrl(loginUrl: string, origin: string): string {
  const url = new URL(loginUrl);
  url.searchParams.set('signedOut', '1');
  url.searchParams.set('returnUrl', `${origin}${CALLBACK_PATH}?next=${encodeURIComponent('/')}`);
  return url.toString();
}

/** Best-effort logout on the auth origin, then clear memory and go to the signed-out screen. */
export async function signOut(): Promise<void> {
  try {
    await authApi.logout();
  } catch {
    /* best effort — the user still leaves */
  }
  clearAuth();
  browser.assign(signedOutUrl(getBootstrap().loginUrl, window.location.origin));
}

